import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';

class SeminarChula1 extends Component {
  state = {
    registered: {}
  };

  componentDidMount() {
    // Load saved registration state from localStorage
    const saved = localStorage.getItem("registered_chula");
    if (saved) {
      this.setState({ registered: JSON.parse(saved) });
    }
  }

  handleRegister = (id) => {
    const isRegistered = this.state.registered[id];

    if (isRegistered) {
      // Ask to unregister with PIN
      const pin = window.prompt("Enter PIN to unregister:");
      if (pin === "2323") {
        this.setState((prevState) => {
          const updated = { ...prevState.registered };
          delete updated[id];
          localStorage.setItem("registered_chula", JSON.stringify(updated));
          return { registered: updated };
        });
        alert("Unregistered successfully.");
      } else if (pin !== null) {
        alert("Incorrect PIN. Unregister cancelled.");
      }
    } else {
      // Ask to register
      const confirmRegister = window.confirm("Do you want to register?");
      if (confirmRegister) {
        this.setState((prevState) => {
          const updated = { ...prevState.registered, [id]: true };
          localStorage.setItem("registered_chula", JSON.stringify(updated));
          return { registered: updated };
        });
      }
    }
  };

  renderParticipant = (id, name) => {
    const isRegistered = this.state.registered[id];
    return (
      <div key={id}>
        <span
          onClick={() => this.handleRegister(id)}
          style={{
            color: isRegistered ? "red" : "blue",
            cursor: "pointer"
          }}
        >
          {id}. {name}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div className='RosterTuesday1'>
        <h3>Chulalongkorn University Participants Day 1</h3>
        <br /><br />

        {this.renderParticipant(1, "นายนิวัฒน์ สีสังข์งาม")}
        <br />
        {this.renderParticipant(2, "นายวิชัย ชีวพิทักษ์ผล")}
        <br />
        {this.renderParticipant(3, "นายนฤพร เสาวนิตย์")}
        <br />
        {this.renderParticipant(4, "Mr.Phumiphat Phumariyapong")}
        <br />
        {this.renderParticipant(5, "Ms.Yotsawadee Potippayawong")}
        <br />
        {this.renderParticipant(6, "Mr.Kanapod Konsri")}
        <br />

        <div>
          ASEAN AIKIDO FELLOWSHIP SEMINAR 2025 REGISTRATION SYSTEM...
        </div>
        <br /><br />
        <div>Powered by</div>
        <img className='logo2' src={logo2} alt="logo" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default SeminarChula1;
